// extracted by mini-css-extract-plugin
export default {"modal":"DM-z","modalOverlay":"EM-z","outfitHeading":"FM-z"};